module.exports = __webpack_public_path__ + "img/ClickForSound_32.8aa1e687.png";